<template>
  <div class="contact-info">
   <span
      v-if="loading"
      class="loadingres mr-2 ml-2 spinner-border loading-spinner"
    ></span>
    <div v-if="event && event.name !== undefined">
        <h6>{{event.name}}
          <i class="icon-circle" :class="event.status == 'active' ? 'text-success': 'text-danger'"></i>
          <small v-if="event.cancellation !== undefined && event.cancellation.canceler_type !== undefined && event.cancellation.canceler_type == 'host'" class="badge badge-danger ml-2"> {{$t('lang.opportunities.canceledbyclient')}}: {{event.cancellation.canceled_by}} </small>
        </h6>
        <div class="">
          <h6 class="mr-2"> {{$t('lang.column.eventdate')}}:
          </h6>
          <strong class="text-primary">
          <i class="icon-calendar mr-1" ></i> <span v-if="!editingDate">{{event.start_time}}</span></strong>
            <date-picker
              v-if="editingDate"
              id="endDatePicker"
              style="width:250px;position:relative;"
              class="d-inline p-0 ml-2 text-center w-auto"
              v-model="event.start_time"
              :config="datePickerConfigEndDate"
              placeholder="Event Date"></date-picker>
          <strong class="text-secondary ml-1" v-if="event.timezone !== undefined">({{event.timezone.zone_name}})</strong>
          <div class="d-inline">
            <strong v-if="!editingDate && event.calendar_event == undefined &&  false" @click="editingDate=true"><i class="icon-pencil ml-1 text-white bg-primary p-1 rounded-circle"></i></strong>
            <strong v-if="editingDate" @click="editingDate=false;changeEventDate(event.start_time)"><i class="icon-checkmark ml-1 text-white bg-success p-1 rounded-circle"></i></strong>
          </div>
          <div>
          <small v-if="editingDate" class="text-danger">Warning<i class="icon-warning text-warning"></i>: {{$t('lang.calendar.modifyeventrisk')}}</small>
          </div>
        </div>
        <template v-if="event.location">
          <div v-if="event.location.type != 'outbound_call' && event.location.join_url !== undefined && event.location.join_url != null" class="my-2">
            <h6 class="mt-2">Join the meeting</h6>
            <a :href="event.location.join_url" target="_blank" class="text-primary d-block ml-3">
            <small><i class="icon-video-camera mr-2"></i> {{event.location.join_url}}</small>
            </a>
          </div>
        </template>
        <template v-if="event.invitees">
        <div v-if="false" v-for="question in event.invitees[0].questions_and_answers">
            <ul>
              <li v-if="['Entreprise', 'Téléphone'].includes(question.question)">
                <small>
                  <strong>{{question.question}}:</strong> {{question.answer}}
                </small>
              </li>
            </ul>
          </div>
        </template>
        <div v-if="event.invitees !== undefined">
          <h6 class="mt-2">{{$t('lang.appointments.participants')}}</h6>
          <div v-for="invitee in event.invitees">
            <h5><small>
              <Tooltip
                  class="ml-2 text-primary"
                  :text="textToStatusInvitee(invitee)"
                  :width="'auto'" >
                  <i class="icon-circle"  :class="getStatusInvitee(invitee)"></i>
                </Tooltip>
              {{ invitee.name }} {{ invitee.email }}</small></h5>

          </div>
        </div>

        <div  v-if="event.invitees !== undefined"  class="">
          <div class="ml-3" v-for="question in event.invitees[0].questions_and_answers">
            <ul>
              <li>
                <small>
                  <strong>{{question.question}}:</strong> {{question.answer}}
                </small>
              </li>
            </ul>
          </div>
        </div>

        <div v-if="(event.location && event.location.type == 'outbound_call') || event.location.join_url == null" class=" mt-2 ">
          <a :href="'tel:'+event.location.location" class="bg-primary text-white p-1 rounded ml-3 px-2">
          <i class="icon-phone mr-2"></i><small>{{ phoneWithSpaces(event.location.location)}}</small>
          </a>
        </div>
        <div v-if="event.business_contact_data" class="opp card p-2 mt-3">
          <div class="mt-1">
            <div class="mb-2">
                {{$t('lang.column.contacted_person')}}:
            </div>
            <div class="d-flex"><strong>{{ event.business_contact_data.first_name }} {{ event.business_contact_data.last_name }}</strong>
              <a v-if="event.business_contact_data.linkedinurl" class="ml-2"
              :href="event.business_contact_data.linkedinurl" target="_blank" rel="noopener noreferrer">
                <i class="icon-linkedin color-ln"></i>
              </a>
            </div>
            <div v-if="event.business_contact_data.job">
              <small>{{replaceChain(event.business_contact_data.job)}}</small>
            </div>
            <div>
              <small class="font-weight-bold text-primary">{{ event.business_contact_data.email }}</small>
            </div>
          </div>
        </div>
        <div class="mt-4 float-right">
         <small>{{$t('lang.column.creationdate')}}: {{event.created_at}} </small>
        </div>

    </div>
  </div>
</template>

<script>
import { calendlyService } from "@/_services";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  components:{ Tooltip },
  data() {
    return {
      event:false,
      loading:true,
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD H:mm",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      editingDate:false
    };
  },
  props: {
    id: String,
    eventCalendly: Object
  },
  created() {
    if(this.id == undefined){
      this.event = this.eventCalendly
      this.loading = false
    }else{
      this.getEvent()
    }

  },
  computed: {
  
    ...mapState({
      opportunity: state => state.opportunities.selected.data,
    }),
    textToStatusInvitee(){
      return (invitee) => {
        if(!invitee.status == undefined){
          return ""
        }
        if(invitee.status == 'canceled' || invitee.status == 'cancelled'){
          return this.$t('lang.opportunities.meeting_cancelled')
        }
        if(invitee.status == 'confirmed' || invitee.status == 'active'){
          return this.$t('lang.opportunities.invite_accepted')
        }
        if(invitee.status == 'maybe'){
          return this.$t('lang.opportunities.invite_pending')
        }
        return ""
      }
    },
    phoneWithSpaces(){
      return (value) => {
        let phone = ''
        if(value.length > 0){
          value.replace(/\s+/g, '')
                .split('')
                .forEach( ( digit, i ) => {
                  if(i % 2 ){
                    phone += digit
                  } else {
                    phone += ' ' + digit
                  }
                })
          phone = '+' + phone
        }
        return phone
      }
    }
  },
  methods: {
    ...mapActions("opportunities", {
      setLoadEvent: "setLoadEvent"
    }),
    getEvent() {
      calendlyService.getEvent(this.id).then((result) => {
         this.loading = false
          this.event = result   
          console.log(result)  
          this.event.business_contact_data = this.event.event_type.includes('calendly') ? '' : JSON.parse(this.event.business_contact_data)

          if(this.opportunity != undefined){
            this.opportunity.link.event = this.event
             this.setLoadEvent(true)
            
          }
      })
    },
    replaceChain(chain){
      if(chain!=null){
        var search = '&amp;';
        var str=chain;
        str=str.replace(new RegExp(search,"g") ,"&");
        return str
      }
    },
    getStatusInvitee(invitee){
      if(invitee.status == undefined){
        return "text-secondary"
      }
      if(invitee.status == 'noreply'){
        return "text-secondary"
      }
      if(invitee.status == 'no'){
        return "text-danger"
      }
      if(invitee.status == 'canceled' || invitee.status == 'cancelled'){
        return "text-danger"
      }
      if(invitee.status == 'yes'){
        return "text-success"
      }
      if(invitee.status == 'confirmed'){
        return "text-success"
      }
      if(invitee.status == 'maybe'){
        return "text-warning"
      }
      if(invitee.status == 'active'){
        return "text-success"
      }

      return "text-white"

    },
    changeEventDate(start_time){
      this.$swal({
        type: "warning",
        title: this.$t('lang.calendar.modifysure'),
        text: this.$t('lang.calendar.modifyevent'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.ok"),
      }).then((result) => {
        if (result.value) {
          this.$router.push("/settings-account");
        }
      });
    }
  }
};
</script>
<style scoped>
  .opp.card:hover,.opp.card{
  transform: none!important;
  box-shadow: 0px !important;
  transition: none !important;
}
</style>
